import { useState, useRef, useEffect } from 'react'
import { ChevronRight, PlaySquare, ChevronLeft } from 'lucide-react'

// Importing images
import a1 from '../../../../public/images/a1.jpg'
import a2 from '../../../../public/images/a2.png'
import a3 from '../../../../public/images/a3.jpg'
import a4 from '../../../../public/images/a4.jpg'
import a5 from '../../../../public/images/a5.jpg'
import a6 from '../../../../public/images/a6.png'
import a7 from '../../../../public/images/a7.jpg'
import a8 from '../../../../public/images/a8.jpg'

const games = [
    { id: "1", title: "Andar Bahar", provider: "Ezugi", image: a1 },
    { id: "2", title: "Super Sic Bo", provider: "Evolution", image: a2 },
    { id: "3", title: "Gold Vault Roulette", provider: "Evolution", image: a3 },
    { id: "4", title: "Claw Roulette", provider: "Ezugi", image: a4 },
    { id: "5", title: "Skyline Roulette", provider: "Ezugi", image: a5 },
    { id: "6", title: "Roulette", provider: "Evolution", image: a6 },
    { id: "7", title: "Crazy Time", provider: "Evolution", image: a7 },
    { id: "8", title: "Lucky", provider: "Ezugi", image: a8 },
]

export default function LiveCasinoCarousel() {
    const [currentIndex, setCurrentIndex] = useState(0)
    const [isAtStart, setIsAtStart] = useState(true)
    const [isAtEnd, setIsAtEnd] = useState(false)
    const carouselRef = useRef(null)

    const nextSlide = () => {
        const newIndex = currentIndex + 1 >= games?.length ? games?.length - 1 : currentIndex + 1
        setCurrentIndex(newIndex)
        setIsAtStart(false)
        setIsAtEnd(newIndex === games?.length - 1)
    }

    const prevSlide = () => {
        const newIndex = currentIndex - 1 < 0 ? 0 : currentIndex - 1
        setCurrentIndex(newIndex)
        setIsAtStart(newIndex === 0)
        setIsAtEnd(false)
    }

    useEffect(() => {
        if (carouselRef.current) {
            carouselRef.current.style.transform = `translateX(-${currentIndex * 210}px)`
        }
    }, [currentIndex])

    return (
        <div className='w-[calc(100vw-20px)] md:max-w-[calc(100vw-130px)]'>
            <div className="max-w-full">
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                        <PlaySquare className="w-6 h-6 text-yellow-400" />
                        <h2 className="text-xl font-semibold bg-gradient-to-t from-[#009ae5] to-[#46c2ff] bg-clip-text text-transparent">Live Casino</h2>
                    </div>
                    <button className="flex items-center text-sm text-gray-400 hover:text-white transition-colors">
                        All
                        <ChevronRight className="w-4 h-4" />
                    </button>
                </div>

                <div className="relative overflow-auto md:overflow-hidden">
                    <div
                        ref={carouselRef}
                        className="flex transition-transform duration-300 ease-in-out"
                        style={{ width: `${games?.length * 210}px` }}
                    >
                        {games.map((game) => (
                            <div
                                key={game.id}
                                className="relative group shrink-0 w-[200px] mr-2"
                            >
                                <div className="overflow-hidden rounded-lg">
                                    <div className="relative aspect-[4/2] overflow-hidden">
                                        <img
                                            src={game.image}
                                            alt={game.title}
                                            className="object-cover transition-transform w-[100%] h-[100%] group-hover:scale-110"
                                        />
                                        <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                            <button className='hover:bg-[#0095de] hover:text-white h-[30px] font-semibold rounded-[3px] text-[#0095de] border border-[#0095de] w-2/4' variant="secondary" size="sm">
                                                Play
                                            </button>
                                        </div>
                                        <div className="absolute top-[70px] left-2">
                                            <div className="px-2 py-1 text-xs text-white bg-black/50 w-[100%] h-[100%] rounded-sm backdrop-blur-sm">
                                                {game.provider}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-2 bg-gray-900">
                                        <h3 className="text-sm font-medium text-white truncate">{game.title}</h3>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <button
                        variant="ghost"
                        size="icon"
                        className="absolute top-1/2 left-2 -translate-y-1/2 disabled:opacity-50 hidden md:block"
                        onClick={prevSlide}
                        disabled={isAtStart}
                    >
                        <ChevronLeft className="w-6 h-6" />
                    </button>
                    <button
                        variant="ghost"
                        size="icon"
                        className="absolute top-1/2 right-2 -translate-y-1/2 disabled:opacity-50 hidden md:block"
                        onClick={nextSlide}
                        disabled={isAtEnd}
                    >
                        <ChevronRight className="w-6 h-6" />
                    </button>
                </div>
            </div>
        </div>
    )
}
